import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ICurrency } from '../../interfaces/ICurrency';
import { WarningOutlined } from '@ant-design/icons';

interface Props {
    currency: ICurrency | undefined;
    isLoaded: boolean;
}

const CurrencyForVoucher: React.FC<Props> = ({
    currency,
    isLoaded
}) => {
    const { t } = useTranslation();

    const voucherCurrencyLabel = t('redeemLocationsPage.voucherCurrencyLabel');

    //console.log(`loading voucher currency display with currency : ${currency} and loaded: ${isLoaded}`);

    //No currency provided
    if (currency === undefined) {
        return (
            <>
                <Typography.Text style={{ fontWeight: 'bold' }}>
                    {voucherCurrencyLabel} : {isLoaded && <WarningOutlined style={{ color: "red", fontSize: 30, width: "100%" }} />}
                </Typography.Text>
            </>
        );
    }

    const currencyDescription = t(
        `globalGiftVouchers.currencyPicker.currencyDescription.${currency.code}`
    );

    const voucherCurrencyDescription = `${currency.symbol} - ${currency.code} - ${currencyDescription}`;

    return (
        <>
            <Typography.Text>
                <span style={{ fontWeight:'bold' }} >{voucherCurrencyLabel}</span> : {voucherCurrencyDescription}
            </Typography.Text>

        </>
    );
};

export default CurrencyForVoucher;
